import { Badge } from "@patient-watch/ui/badge";
import { cn } from "@/lib/utils";
import { EntryValueLabel } from "../EntryValueLabel";
import { ClockFading } from "lucide-react";
import React from "react";

interface TriedTreatmentValue {
    hasTried: boolean;
    duration: string;
    isOngoing?: string;
}

interface Props {
    value: TriedTreatmentValue;
    className?: string;
    inputLabel: string;
}

const durationMap = {
    less_than_1_month: "Less than 1 month",
    "1_to_3_months": "1-3 months",
    "3_to_6_months": "3-6 months",
    "6_to_12_months": "6-12 months",
    more_than_12_months: "More than 12 months",
} as const;

const formatDuration = (duration: string) => {
    return durationMap[duration as keyof typeof durationMap] || duration;
};

const TriedTreatmentEntryValue = ({ value, className, inputLabel }: Props) => {
    if (!value?.hasTried) {
        return <div className={cn("text-slate-600 dark:text-slate-400", className)}>Not tried</div>;
    }

    return (
        <div className={cn("flex flex-col gap-2 rounded-md w-full", className)}>
            <EntryValueLabel size="md">{inputLabel}</EntryValueLabel>
            <div className="inline-flex items-center gap-1 text-slate-800 dark:text-slate-100">
                <ClockFading size={20} /> Duration: {formatDuration(value.duration)}
            </div>
            {value.isOngoing && (
                <Badge className="w-fit" variant="default">
                    Status: {value.isOngoing === "yes" ? "Ongoing" : "Not ongoing"}
                </Badge>
            )}
        </div>
    );
};

export default TriedTreatmentEntryValue;
